import { Controller } from "@hotwired/stimulus"

// Powers the role permission grid: a checkbox per module ticks/unticks every
// permission in that module, and the top-level toggle does the whole grid.
export default class extends Controller {
  static targets = ["group", "master"]

  toggleGroup(event) {
    const group = event.currentTarget.closest("[data-permission-matrix-target='group']")
    this.setAll(group, event.currentTarget.checked)
    this.syncMaster()
  }

  toggleAll(event) {
    this.groupTargets.forEach((group) => {
      this.setAll(group, event.currentTarget.checked)
      const header = group.querySelector("[data-role='group-toggle']")
      if (header) header.checked = event.currentTarget.checked
    })
  }

  syncGroup(event) {
    const group = event.currentTarget.closest("[data-permission-matrix-target='group']")
    const boxes = this.boxes(group)
    const header = group.querySelector("[data-role='group-toggle']")
    if (header) header.checked = boxes.length > 0 && boxes.every((box) => box.checked)
    this.syncMaster()
  }

  syncMaster() {
    if (!this.hasMasterTarget) return
    const all = this.groupTargets.flatMap((group) => this.boxes(group))
    this.masterTarget.checked = all.length > 0 && all.every((box) => box.checked)
  }

  boxes(group) {
    return [...group.querySelectorAll("input[type='checkbox'][name='role[permissions][]']:not(:disabled)")]
  }

  setAll(group, checked) {
    this.boxes(group).forEach((box) => { box.checked = checked })
  }
}
